export default __webpack_public_path__ + "static/media/visorBackground.667fecd3.jpg";